import { useMemo, useState, type ReactNode } from 'react'

import { PickerContext, type PickerValue } from './dragPicker'

/**
 * Провайдер выбранного элемента для перетаскивания.
 *
 * Хелперы и хук живут в `dragPicker.ts` — в одном файле с компонентом они
 * ломали бы горячую перезагрузку.
 */
export function DragPickerProvider({ children }: { children: ReactNode }) {
  const [picked, setPicked] = useState<string | null>(null)

  const value = useMemo<PickerValue>(
    () => ({
      picked,
      pick: setPicked,
      isPicked: (key: string) => picked === key,
    }),
    [picked],
  )

  return <PickerContext.Provider value={value}>{children}</PickerContext.Provider>
}
